<div class="p-relative flex justify-between">
    <h4 mat-dialog-title>Редактирование заявок</h4>
    <app-close-button [formGroup]="multiEditForm" [dialogRef]="dialogRef"/>
</div>
<mat-dialog-content>
<app-loader [isLoading]="loading()"/>
    <form class="flex-column pb-0-5 " [formGroup]="multiEditForm" (ngSubmit)="onSubmit()">
        <mat-form-field class="w-100">
            <app-common-date-range (dateRangeChanged)="changeDate($event)"/>
            <app-common-date-range-errors [form]="multiEditForm"/>
        </mat-form-field>
        <!-- Добавил выбор группы для возможности перекинуть заявки на работника из другой группы -->
        <app-group-selector [formCtrl]="groupControl" [label]="'Группа'"></app-group-selector>

        @if (groupControl.value) {
            <app-person-selector [formCtrl]="executorControl" [label]="'Работник'" [additionalParams]="additionalParams"></app-person-selector>
        }

        <mat-form-field>
            <mat-label>Статус заявки</mat-label>
            <mat-select formControlName="status">
                @for (status of enumService.enumTranslateStatusToArrSelects(OrderStatusEnum); track status.value) {
                    <mat-option [value]="status.value">{{status.label}}</mat-option>
                }
            </mat-select>
            @if (multiEditForm.get('status')!.hasError('noExecutor')) {
                <mat-error>
                    Статус не может быть изменен. У заявок не назначен работник.
                </mat-error>
            }
        </mat-form-field>

        <button mat-flat-button type="submit" [disabled]="multiEditForm.invalid || loading()">
            Сохранить изменения
        </button>
    </form>
</mat-dialog-content>

